import { EmptyState } from '@coast/schemas';
import { Image } from '@shared/components/Image';
import { MBEmptyListPlaceholder } from '@shared/components/list';
import classNames from './emptyState.module.css';

interface Props extends EmptyState {
  testID?: string;
}

export function MBCardEmptyState({ title, message, imageUri, testID }: Props) {
  return (
    <MBEmptyListPlaceholder
      title={title}
      description={message}
      image={
        !!imageUri && (
          <Image source={{ uri: imageUri }} className={classNames.image} resizeMode="contain" />
        )
      }
      testID={testID}
      className={classNames.cardEmptyState}
    />
  );
}
